export default __webpack_public_path__ + "static/media/gallery-wip-handle_05.e44150a4.jpg";